export default "__VITE_ASSET__P2__kl4E__"